const LOCAL_STORAGE_COUPON = 'pharmedistore_shipping'

const SHIPPING_MANAGER = {
  add: value => {
    const oldShippings = SHIPPING_MANAGER.list()
    const newShippings = [...oldShippings, value]

    SHIPPING_MANAGER._set(newShippings)
  },

  remove: value => {
    const oldShippings = SHIPPING_MANAGER.list()
    const newShippings = oldShippings.filter(v => v !== value)

    SHIPPING_MANAGER._set(newShippings)
  },

  list: () => {
    if (typeof window !== 'undefined')
      return JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_COUPON) || '[]')
  },

  // private method
  _set: value => {
    if (typeof window !== 'undefined')
      window.localStorage.setItem(LOCAL_STORAGE_COUPON, JSON.stringify(value))
  },
  reset: () => {
    if (typeof window !== 'undefined') window.localStorage.removeItem(LOCAL_STORAGE_COUPON)
  },
}

export default SHIPPING_MANAGER
